import React, { useState } from "react";
import { Check, Loader2, CalendarCheck } from "lucide-react";
import api from "../lib/api";
import CurrencySelect from "./CurrencySelect";
import PayPalCheckout from "./PayPalCheckout";

const PACKAGES = [
  {
    id: "web_basic",
    name: "Basic Setup",
    range: "$250 – $600",
    highlight: false,
    features: [
      "Simple 3–5 page website",
      "Home, About, Services, Contact",
      "Quote request form",
      "Basic branding",
      "Contact forms",
    ],
  },
  {
    id: "web_standard",
    name: "Standard Trucking Website",
    range: "$650 – $1,500",
    highlight: true,
    features: [
      "Everything in Basic",
      "Load board integration / links",
      "Carrier packet download",
      "Quote request forms",
      "SEO basics",
      "Mobile optimization",
    ],
  },
  {
    id: "web_premium",
    name: "Premium Website",
    range: "$1,300 – $3,000+",
    highlight: false,
    features: [
      "Custom branding",
      "Online booking + client portal",
      "Payment integration",
      "Dispatch application forms",
      "Blog + advanced SEO",
      "Ongoing support",
    ],
  },
];

const WebPackages = () => {
  const [loadingId, setLoadingId] = useState(null);
  const [curCode, setCurCode] = useState("USD");

  const pay = async (pkg) => {
    setLoadingId(pkg.id);
    try {
      const r = await api.post("/payments/checkout", {
        package_id: pkg.id,
        origin_url: window.location.origin,
        currency: curCode.toLowerCase(),
      });
      window.location.href = r.data.checkout_url;
    } catch (err) {
      setLoadingId(null);
      alert("Could not start checkout. Please try again or call dispatch.");
    }
  };

  return (
    <section className="webpkg" id="web-design">
      <div className="container">
        <div className="section-head">
          <span className="kicker">Website & Flyer Design</span>
          <h2>Website packages for trucking businesses</h2>
          <p>Pay a flat <strong>$50 deposit</strong> to get started — the remaining balance is only due after your site is built and you're happy with it.</p>
          <div className="pkg-currency">Pay in: <CurrencySelect value={curCode} onChange={setCurCode} testid="webpkg-currency" /></div>
        </div>

        <div className="pkg-grid">
          {PACKAGES.map((p) => (
            <div className={`pkg-card ${p.highlight ? "featured" : ""}`} key={p.id}>
              {p.highlight && <span className="pkg-badge">Most Popular</span>}
              <h3>{p.name}</h3>
              <div className="pkg-price">{p.range}</div>
              <ul className="pkg-features">
                {p.features.map((f, i) => (
                  <li key={i}><Check size={16} /> {f}</li>
                ))}
              </ul>
              <button className={`btn ${p.highlight ? "btn-primary" : "btn-pay"} btn-block`} onClick={() => pay(p)} disabled={loadingId === p.id}>
                {loadingId === p.id ? <Loader2 size={16} className="spin" /> : null}
                Get Started · $50 deposit
              </button>
              <PayPalCheckout packageId={p.id} currency={curCode} />
              <button className="pkg-consult" onClick={() => window.dispatchEvent(new Event("open-consultation"))}>
                <CalendarCheck size={14} /> Book a consultation first
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WebPackages;
